module.exports = __webpack_public_path__ + "65bb393e6421840be158c634655317dc.svg";